<template>
  <section class="credits" v-if="show_banner !== false">
    <div>
      <div>
        <span v-html="$t('footer.banner', { link: site.url, name: site.name })"></span>
      </div>
    </div>
  </section>
</template>

<script>
  export default {
    computed: {
      site () {
        return window.site || {url: '', name: 'localhost'};
      },

      show_banner () {
        return this.$store.state.Module.active_module.settings.module.show_banner;
      },

      show_language () {
        return this.$store.state.Module.active_module.settings.module.show_language;
      },
    }
  };
</script>

<style>
  section.credits {
    padding: 10px 20px;
    background-color: #313131;
  }

  section.credits span {
    color: #fff;
  }

  section.credits a {
    color: #469AEA;
  }
</style>



// WEBPACK FOOTER //
// footer-bar.vue?053fd6a5